import React from "react";
import { useRoutes } from "react-router-dom";

// MSAL
import { AuthenticatedTemplate } from "@azure/msal-react";

//Components
import HomePage from "./components/HomePage";

//Admin
import AdminLayout from "./layouts/admin";
import BUPage from "./admin/bu/BUPage";
import ContractTypePage from "./admin/contract-type/ContractTypePage";
import CustomerTypePage from "./admin/customer-type/CustomerTypePage";
import CustomerPage from "./admin/customer/CustomerPage";
import SegmentClassificationPage from "./admin/segment-classification/SegmentClassificationPage";
import SegmentLOBPage from "./admin/segment-lob/SegmentLOBPage";
import FinanacePage from "./admin/finance/FinancePage";
import SBGPage from "./admin/sbg/SBGPage";
import SBUPage from "./admin/sbu/SBUPage";
import UserPage from "./admin/user/UserPage";
import CountryPage from "./admin/country/CountryPage";
import StatePage from "./admin/state/StatePage";
import CompetitionIntensityPage from "./admin/competition-intensity/CompetitionIntensityPage";
import GeographyPage from "./admin/geography/GeographyPage";
import TenderBandwidthPage from "./admin/tender-bandwidth/TenderBandwidthPage";
import CsgoPage from "./admin/csgo/CsgoPage";
import RolePage from "./admin/role/RolePage";
import CustomerGreenClassificationPage from "./admin/customer-green-classfication/CustomerGreenClassificationPage";
import SegmentClassificationMapPage from "./admin/segment-classification-map/SegmentClassificationMapPage";
import SBUBUMappingPage from "./admin/sbu-bu-mapping/SBUBUMappingPage";
import SegmentBUMapPage from "./admin/segment-bu-map/SegmentBUMapPage";
import UserHierarchyPage from "./admin/user-hierarchy/UserHierarchyPage";
import ProjectPage from "./admin/project/ProjectPage";
import ProjectCompetitorsPage from "./admin/ProjectCompetitors/ProjectCompetitorsPage";
import ProjectsWinLossPage from "./admin/projects-winloss/ProjectsWinLossPage";
import ProjectStatusPage from "./admin/projectStatus/ProjectStatusPage";

const Router = () =>
  useRoutes([
    {
      path: "/",
      element: <HomePage />,
    },
    {
      path: "/admin",
      element: (
        <AuthenticatedTemplate>
          <AdminLayout />
        </AuthenticatedTemplate>
      ),
      children: [
        {
          index: true,
          element: <BUPage />,
        },
        {
          path: "bu",
          element: <BUPage />,
        },
        {
          path: "contractType",
          element: <ContractTypePage />,
        },
        {
          path: "customerType",
          element: <CustomerTypePage />,
        },
        {
          path: "customers",
          element: <CustomerPage />,
        },
        {
          path: "projects",
          element: <ProjectPage />,
        },
        {
          path: "projectsStatus",
          element: <ProjectStatusPage />,
        },
        {
          path: "segmentClassifications",
          element: <SegmentClassificationPage />,
        },
        {
          path: "segmentLOBs",
          element: <SegmentLOBPage />,
        },
        {
          path: "fundingSources",
          element: <FinanacePage />,
        },
        {
          path: "sbg",
          element: <SBGPage />,
        },
        {
          path: "sbu",
          element: <SBUPage />,
        },
        {
          path: "users",
          element: <UserPage />,
        },
        {
          path: "countries",
          element: <CountryPage />,
        },
        {
          path: "states",
          element: <StatePage />,
        },
        {
          path: "competitionIntensities",
          element: <CompetitionIntensityPage />,
        },
        {
          path: "geographies",
          element: <GeographyPage />,
        },
        {
          path: "tenderBandwidths",
          element: <TenderBandwidthPage />,
        },
        {
          path: "csgo",
          element: <CsgoPage />,
        },
        {
          path: "roles",
          element: <RolePage />,
        },
        {
          path: "customerGreenClassifications",
          element: <CustomerGreenClassificationPage />,
        },
        {
          path: "segmentClassificationMap",
          element: <SegmentClassificationMapPage />,
        },
        {
          path: "sbubumapping",
          element: <SBUBUMappingPage />,
        },
        {
          path: "segmentbumapping",
          element: <SegmentBUMapPage />,
        },
        {
          path: "userhierarchy",
          element: <UserHierarchyPage />,
        },
        {
          path: "projectcompetitors",
          element: <ProjectCompetitorsPage />,
        },
        {
          path: "projectswinloss",
          element: <ProjectsWinLossPage />,
        },
      ],
    },
  ]);

export default Router;
